import VehicleDetail from './VehicleDetail';
export default VehicleDetail;
